import Vue from 'vue'
import jQuery from 'jquery'

// import ClipboardJS from 'clipboard'

import FanCountFacebook from '@/components/parts/FanCountFacebook.vue'
import FanCountInstagram from '@/components/parts/FanCountInstagram.vue'

// import jQuery from 'jquery'
import config from '@/../myconfig.js'
window.jQuery = window.$ = jQuery

require('gifler')
require('imagesloaded')
require('magnific-popup')
require('@/assets/theme/bkkmenu-2017/assets/js/slick/slick.min.js')
// require('@/assets/theme/bkkmenu-2017/assets/js/magnific-popup/jquery.magnific-popup.js')
require('@/assets/theme/bkkmenu-2017/assets/gallery/js/gallery.js')

Vue.config.productionTip = false

function addQS (d, c) {
  let a = []
  for (let b in c) { if (c[b]) a.push(b.toString() + '=' + encodeURIComponent(c[b])) }
  return d + '?' + a.join('&')
}

$(document).ready(() => {
  $('.nav-tools').each(function () {
    let items = $(this).find('.tool')
    let total = items.length

    if (total == 2) {
      $(this).addClass('tool-2items')
    } else if (total == 3) {
      $(this).addClass('tool-3items')
    }

    setTimeout(function () {
      $('.nav-tools').css('opacity', '1')
    }, 10)
  })

  if ($('.copytoclipboard').length > 0) {
    $('.copytoclipboard').click(function (e) {
      $('body').append('<input type="text" id="__tempCopy" style="position: fixed; top:-1000; left: -1000;" value="' + $(this).attr('aria-label') + '">')
      $('#__tempCopy').focus().select()

      let msg = document.execCommand('copy')
      if (msg) {
        $('#sharebox').hide()
        $('#clipboard').fadeIn(300)
        setTimeout(function () {
          $.magnificPopup.close()
        }, 1500)
      }

      e.preventDefault()
    })
  }

  $('*[data-share]').click(function (e) {
    switch ($(this).data('share')) {
      case 'facebook':
        let a1 = addQS('https://www.facebook.com/sharer.php', {
          u: document.URL,
          title: document.title
        })
        window.open(a, 'sharer', 'toolbar=0,status=0,width=626,height=436')
        break

      case 'twitter':
        let a2 = addQS('http://twitter.com/share', {
          url: document.URL,
          text: document.title + ' - '
        })
        window.open(a, 'tweet', 'toolbar=0,status=0,width=626,height=436')
        break

      case 'lineMsg':
        window.location = 'line://msg/text/' + encodeURIComponent(document.URL)
        break
    }

    e.preventDefault()
  })

  if ($('.quote-slider').length) {
    $('.quote-slider').each(function () {
      let slider = $(this)
      let items = slider.find('.item')
      let total = items.length

      slider.slick({
        dots: true,
        arrows: true,
        infinite: true,
        speed: 800,
        autoplay: true,
        autoplaySpeed: 8000,
        pauseOnFocus: false,
        pauseOnHover: false,
        adaptiveHeight: true
      })
    })
  }

  $('.open-popup-share').magnificPopup({
    type: 'inline',
    preloader: false,
    closeOnBgClick: true,
    mainClass: 'popup-style popup-style-lightbox',
    showCloseBtn: false,
    removalDelay: 290,
    callbacks: {
      open: function () {
        $('#sharebox').show()
        $('#clipboard').hide()
      }
    }
  })

  $('.open-popup-save').magnificPopup({
    type: 'inline',
    preloader: false,
    closeOnBgClick: true,
    mainClass: 'popup-style popup-style-lightbox',
    showCloseBtn: false,
    removalDelay: 290,
    callbacks: {
      open: function () {
        setTimeout(function () {
          $.magnificPopup.close()
        }, 1500)
      }
    }
  })

  $(document).on('click', '.modal-dismiss', function (e) {
    e.preventDefault()
    $.magnificPopup.close()
  })

  $('canvas.play-pause').each(function () {
    let elem = $(this)
    let path = $(this).data('url')
    gifler(path)
      .animate('canvas.play-pause', function (animator) {
        $('canvas.play-pause').click(function () {
          if (animator.running()) {
            animator.stop()
          } else {
            animator.start()
          }
        })
      })
  })
})

if (document.getElementById('fancount-facebook-desktop')) {
  new Vue({
    render: h => h(FanCountFacebook)
  }).$mount('#fancount-facebook-desktop')
}

if (document.getElementById('fancount-instagram-desktop')) {
  new Vue({
    render: h => h(FanCountInstagram)
  }).$mount('#fancount-instagram-desktop')
}

if (document.getElementById('fancount-facebook-mobile')) {
  new Vue({
    render: h => h(FanCountFacebook)
  }).$mount('#fancount-facebook-mobile')
}

if (document.getElementById('fancount-instagram-mobile')) {
  new Vue({
    render: h => h(FanCountInstagram)
  }).$mount('#fancount-instagram-mobile')
}
